const PlaneSide = ({
  className = "",
  color,
}: {
  className?: string;
  color: string;
}) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      data-name="layer2"
      d="M50.415 36.139C38.68 31.381 15.723 21.826 15.723 21.826a2.68 2.68 0 0 1-1.758-2.726c.014-1.574-1.234-4.8-3.445-5.682-1.094-.435-2.387-.889-2.387-.889l-.75 12.357a2.5 2.5 0 0 0 1.48 1.761c.484.234 6.926 3.371 14.937 7.272l-13.859 10a10.4 10.4 0 0 0 8.559 1.613c4.684-1.35 18.635-5.12 18.641-5.12C47.536 45.479 56.821 50 56.821 50s5.25-9.259-6.406-13.861z"
      fill={color}
    ></path>
    <path
      data-name="layer1"
      d="M38.368 31.2l-6.893-13.163a7.7 7.7 0 0 0-5.865-3.678c.191 3.612 1.025 11.993 1.025 11.993 3.6 1.492 7.708 3.191 11.726 4.847z"
      fill={color}
    ></path>
    <path
      data-name="opacity"
      d="M38.368 31.2l-6.893-13.163a7.7 7.7 0 0 0-5.865-3.678c.191 3.612 1.025 11.993 1.025 11.993 3.6 1.492 7.708 3.191 11.726 4.847z"
      fill="#000064"
      opacity=".15"
    ></path>
  </svg>
);

export default PlaneSide;
